<template>
  <el-row :gutter="24">
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-col :span="18">
      <el-row :gutter="24" style="margin-top: 10px">
        <el-col :span="6">
          <mWidget
            :data="{isim: '30 Gün Upload', sayi: this.Rapor.AylikUpload, icon: 'el-icon-upload2', renk: 'ins2 m-widget-mini'}"></mWidget>
        </el-col>
        <el-col :span="6">
          <mWidget
            :data="{isim: '30 Gün Download', sayi: this.Rapor.AylikDownload, icon: 'el-icon-download', renk: 'ins4 m-widget-mini'}"></mWidget>
        </el-col>
        <el-col :span="6">
          <mWidget
            :data="{isim: 'Aktif Upload', sayi: this.Rapor.AnlikUpload, icon: 'el-icon-arrow-up', renk: 'ins8 m-widget-mini'}"></mWidget>
        </el-col>
        <el-col :span="6">
          <mWidget
            :data="{isim: 'Aktif Download', sayi: this.Rapor.AnlikDownload, icon: 'el-icon-arrow-down', renk: 'ins9 m-widget-mini'}"></mWidget>
        </el-col>
      </el-row>
      <h5>
        <small>Aktif Kullanıcı Listesi</small>
        <el-button size="mini" @click="SayfaYukle()" style="margin-top:-2px" class="float-right">Yenile</el-button>
      </h5>

      <el-table
        class="table-xs"
        style="width: 100%"
        width="100%"
        :data="MeskenListe"
        v-if="MeskenListe"
        :height="Height">

        <el-table-column
          label="B.Türü"
          prop="Tur"
          width="100">
        </el-table-column>
        <el-table-column
          label="Kullanıcı"
          prop="Tanim">
          <template slot-scope="scope">
            <i class="flaticon2-user"></i>
            <span>{{ scope.row.Tanim }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Başlama Zamanı"
          prop="Baslangic"
          width="130">
          <template slot-scope="scope">
            <i class="flaticon2-crisp-icons-1"></i>
            <span>{{ scope.row.Baslangic }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="İp Adresi"
          prop="ip"
          width="120">
        </el-table-column>
        <el-table-column
          label="Trafik"
          prop="Trafik"
          width="100">
          <template slot-scope="scope">
            <i class="text-mavi flaticon2-line-chart"></i>
            <b class="text-mavi">{{ scope.row.Trafik }}</b>
          </template>
        </el-table-column>
        <el-table-column
          label="Lokasyon"
          prop="Lokasyon"
          width="100">
        </el-table-column>
        <el-table-column
          label="Tarife"
          prop="Tarife"
          width="150">
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="6" style="margin-top: 10px">
      <mWidget
        :data="{isim: 'Aktif Mesken Sayısı', sayi: this.Kullanici.Aktif, icon: 'el-icon-circle-check', renk: 'ins1 m-widget-mini'}"></mWidget>
      <mWidget
        :data="{isim: 'Toplam Mesken Sayısı', sayi: this.Kullanici.Toplam, icon: 'el-icon-circle-plus-outline', renk: 'ins3 m-widget-mini'}"></mWidget>
      <mWidget
        :data="{isim: 'Pasif Mesken Sayısı', sayi: this.Kullanici.Pasif, icon: 'el-icon-circle-close', renk: 'ins5 m-widget-mini'}"></mWidget>
      <mWidget
        :data="{isim: 'Modem Resetleyen Mesken Sayısı', sayi: this.Kullanici.Modem, icon: 'el-icon-loading', renk: 'ins7 m-widget-mini'}"></mWidget>
      <h5><small>30 Günlük Kullanıcı Analizi</small></h5>
      <table class="table table-xs">
        <thead>
        <tr>
          <th>Kullanıcı</th>
          <th class="text-right">Trafik</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="a in Analiz">
          <td><i class="flaticon2-user"></i> {{a.Tanim}}</td>
          <td class="text-right"><i class="flaticon2-line-chart"></i> {{a.Trafik}}</td>
        </tr>
        </tbody>
      </table>
      <table class="table table-xs">
        <thead>
        <tr>
          <th>Modem Resetleyen Meskenler</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in ResetModem">
          <td class="text-danger"><i class="flaticon2-user"></i> {{r.Tanim}}</td>
        </tr>
        </tbody>
      </table>
    </el-col>
  </el-row>
</template>

<script>
  import mWidget from "../Genel/mWidget";
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, mWidget},
    props: ['Bina_id'],
    data() {
      return {
        MeskenListe: null,
        Analiz: null,
        ResetModem: null,
        lo: false,
        Height: '66vh',
        Kullanici: {
          Aktif: 0,
          Toplam: 0,
          Pasif: 0,
          Modem: 0,
        },
        Rapor: {
          AylikUpload: 0,
          AylikDownload: 0,
          AnlikUpload: 0,
          AnlikDownload: 0,
        }
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_radius/kullanici/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.MeskenListe = response.Liste;
              this.Kullanici = response.Kullanici;
              this.Analiz = response.Analiz;
              this.Rapor = response.Rapor;
              this.ResetModem = response.ResetModem;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
      this.Height = '66vh';
    }
  }
</script>

<style scoped>
  h5 {
    padding: 5px;
    background: #eceef6;
    margin-top: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Pack/Internet/InternetKullaniciListesi.vue